export type RetryAttemptOutcomeTone = 'green' | 'red' | 'yellow' | 'blue' | 'gray';

import { RetryPresentationState, StepRun } from '@/types/stepExecutions.ts';

export const getRetryAttemptOutcomeTone = (state: RetryPresentationState): RetryAttemptOutcomeTone => {
  switch (state) {
    case 'succeeded':
      return 'green';
    case 'queued':
    case 'running':
    case 'automatically_retried':
      return 'yellow';
    case 'needs_review':
    case 'automatic_retry_withheld':
      return 'blue';
    case 'stopped':
    case 'retry_limit_reached':
      return 'red';
  }
};

export const selectDisplayedStepRun = (
  stepRuns: StepRun[],
  allowHistoricalStepRuns = false,
): StepRun | undefined => {
  const latestStepRun = stepRuns.find((stepRun) => stepRun.is_latest);
  if (latestStepRun) return latestStepRun;
  if (!allowHistoricalStepRuns) return undefined;
  return stepRuns.reduce<StepRun | undefined>((mostRecentStepRun, stepRun) => {
    if (!mostRecentStepRun) return stepRun;
    return getStepRunTimestamp(stepRun) >= getStepRunTimestamp(mostRecentStepRun) ? stepRun : mostRecentStepRun;
  }, undefined);
};

const getStepRunTimestamp = (stepRun: StepRun): number =>
  parseTimestamp(stepRun.created_at) ?? parseTimestamp(stepRun.step_execution?.created_at) ?? 0;

const parseTimestamp = (value?: string | null): number | undefined => {
  if (!value) return undefined;
  const timestamp = new Date(value).getTime();
  return Number.isFinite(timestamp) ? timestamp : undefined;
};
